import React from "react";
import { GiftCardListPage } from "../../Components/dashboard";

const AdminGiftCardList = () => {
  return <GiftCardListPage role="admin" />;
};

export default AdminGiftCardList;
